// @ts-nocheck
// @ts-nocheck
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Button from '../../../components/Button/Button';

interface Counsellor {
  imageUrl: string;
  name: string;
  description: string;
  profileLink?: string; // Optional link for the profile page
  bookingLink?: string; // Optional link for the booking page
}

interface CounsellorSectionProps {
  imgProps: string;
  title?: string;
  type: string;
  counsellors: Counsellor[];
}

export default function CounsellorSection({
  imgProps,
  title,
  type,
  counsellors,
}: CounsellorSectionProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleViewProfileClick = (link?: string) => {
    if (link) {
      window.location.href = link;
    } else {
      // Optionally handle the case where no profile link is provided
      console.warn('No profile link provided for this counsellor.');
    }
  };

  const handleBookSessionClick = (link?: string) => {
    if (link) {
      window.location.href = link;
    } else {
      // Optionally handle the case where no booking link is provided
      console.warn('No booking link provided for this counsellor.');
    }
  };

  const renderCard = (counsellor: Counsellor, index: number) => (
    <CounsellorCard key={index} imgProps={imgProps}>
      <div>
        <div className="img-container">
          {imgProps !== 'full' && (
            <div>
              <span className="manrope-regular">
                <div className="circular-blob">
                  <div className="inner-blob"></div>
                </div>
                <div>available</div>
              </span>
            </div>
          )}
          <img src={counsellor.imageUrl} alt={counsellor.name} />
        </div>
        <h6 className="manrope-bold">
          <center>{counsellor.name}</center>
        </h6>
        <p className="manrope-regular">
          <center>{counsellor.description}</center>
        </p>
        <div className="btn-container">
          {type === 'profile' && (
            <Button
              variant="primary"
              onClick={() => handleViewProfileClick(counsellor.profileLink)}
            >
              View Profile
            </Button>
          )}
          {type === 'ctoCard' && (
            <Button
              variant="primary"
              onClick={() => handleBookSessionClick(counsellor.bookingLink)}
            >
              Book A Session
            </Button>
          )}
        </div>
      </div>
    </CounsellorCard>
  );

  return (
    <>
      {title && (
        <Container>
          <ContainerBox>
            <Heading className="manrope-semibold heading-color">
              {title}
            </Heading>
          </ContainerBox>
        </Container>
      )}

      <Swiper
        spaceBetween={15}
        slidesPerView={isMobile ? 1.3 : 2.7}
        style={{ padding: '0.5rem 1rem' }}
      >
        {counsellors.map((c, i) => (
          <SwiperSlide key={i}>{renderCard(c, i)}</SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

// ---------- Styled Components ------------
// ... (your styled components remain the same) ...
// ---------- Styled Components ------------

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1155px;
  padding: 2.25px;
  display: flex;
  flex-wrap: wrap;
`;

const Heading = styled.h4`
  font-size: 1.4rem;
  margin: 1.25rem 0rem;
`;

const CounsellorCard = styled.div<{ imgProps: string }>`
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #d3d3d3d3;
  overflow: hidden;
  padding: 0.55rem 0.35rem;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    font-size: 0.7rem;
  }

  img {
    border-radius: ${(props) =>
      props.imgProps === 'full' ? '.45rem' : '100%'};
    width: ${(props) => (props.imgProps === 'full' ? '100%' : '8.5rem')};
    max-width: ${(props) => (props.imgProps === 'full' ? '12rem' : '8.5rem')};
    margin: ${(props) => (props.imgProps === 'full' ? '0' : '0.85rem')};
    border: ${(props) =>
      props.imgProps === 'full' ? 'none' : '3px solid #ea5d0f'};
    padding: ${(props) =>
      props.imgProps === 'circular' ? '0.15rem' : '.25rem'};
  }

  .img-container {
    display: flex;
    justify-content: center;

    span {
      position: absolute;
      display: flex;
      left: 0.25rem;
      align-items: center;
      padding: 0 0.25rem 0 0;
      font-size: 0.65rem;
      border-radius: 0.5rem;
      border: 1px solid #c2d8b5;
      background: #dbffc6;
      color: #91af80;

      .circular-blob {
        margin: 0.25rem;
        height: 12px;
        width: 12px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #9be471;

        .inner-blob {
          height: 4px;
          width: 4px;
          border-radius: 100%;
          background-color: green;
        }
      }
    }
  }

  .btn-container {
    display: flex;
    justify-content: center;
    button {
      margin-bottom: 0;
    }
  }
`;